import { useRef } from 'react';
import { useEventListener } from 'usehooks-ts';

const DEFAULT_INACTIVE_TIME_THRESHOLD = 10 * 60 * 1000;

/**
 * Hook that reloads the page when the tab becomes active after being inactive.
 * Complements helper/registerChunkLoadRecovery, which reactively recovers when
 * a stale lazy chunk fails to load mid-session
 * @param {number} inactiveTimeThreshold - Time in milliseconds after which the page should reload when becoming active (default: 10 minutes)
 */
export const usePageReloadOnFocus = (inactiveTimeThreshold = DEFAULT_INACTIVE_TIME_THRESHOLD) => {
  const documentRef = useRef(document);
  const lastActiveTime = useRef(Date.now());

  const handleVisibilityChange = () => {
    if (documentRef.current?.visibilityState === 'visible') {
      const currentTime = Date.now();
      const timeSinceLastActive = currentTime - lastActiveTime.current;

      if (timeSinceLastActive >= inactiveTimeThreshold) {
        window.location.reload();
      }
    } else {
      lastActiveTime.current = Date.now();
    }
  };

  useEventListener('visibilitychange', handleVisibilityChange, documentRef);
};
